import { Pipe, PipeTransform } from '@angular/core';
import { StringHelpers } from '@lockton-apps/shared/util/helpers';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Args = Record<string, any>;

@Pipe({
  name: 'interpolation',
  standalone: true,
})
export class InterpolationPipe implements PipeTransform {
  transform(value: string, args: Args = {}, complex?: boolean): string {
    return StringHelpers.interpolate(value, args, complex);
  }
}
